export default __webpack_public_path__ + "static/media/singleWrong.86a29d97.mp3";